<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Prijava {{shema}}</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
<div v-if="!pridelovalecid">
    NI PODATKOV
</div>
<div v-else>
<div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            />
                <pridelovalec :pridelovalec="pridelovalec" shema="IP" :sezona="dataSezona.sezona">
          </pridelovalec>
            
          </div>
        </div>
 <div class="uporabnik-spacer" style="margin-top:2rem"></div>
<div class="">
<form @submit.prevent="handleSubmit" class="k-form">
            <div class="form-group">
                  <div class="km-widget km-buttongroup k-widget k-button-group">
                <button class="k-button k-primary" :disabled="pridelovalec.pisanje==0" @click="saveData" >Shrani</button>
                <button class="k-button k-primary" @click="nazaj" >Nazaj</button>
               </div>
             </div>


     <div class="display-flex pt-1">

    <div>
        <fieldset class="left-border-for-children">
            <div class="form-fieldset-header">
                <h2>Prijava in obseg certificiranja</h2>
            </div>

			<div class="display-flex" style="align-items:end;">  
			<label for="datumprijave" class="k-form-field">
            <span>Datum prijave</span>
            <kendo-datepicker id="datumprijave"
                       v-model="ip.prijava.datumprijave"
                       :format="'dd.MM.yyyy'">
            </kendo-datepicker>
            </label>

			<label for="nacin" class="k-form-field flex-grow-1">
                        <span>Način prijave</span>
                        <dropdownlist
                         name="nacin"
                        :data-items="nacinprijaveip"
                        :text-field="'naziv'"
                        v-model="ip.prijava.nacinprijave"
                        />

                        
                </label>
                <router-link title="Preglej prijavo" v-if="eprijava" :to="{ name: 'prijavniObrazecIPPregled',params:{pridelovalecid:eprijava.pridelovalecid,sezona:eprijava.sezona,shema:eprijava.shema}}"  target="_blank">
                                                 <font-awesome-icon size="2x" icon="file-contract"/>
                        </router-link>
			</div>

			<label for="vrsta" class="k-form-field flex-grow-1">
                        <span>Vrsta prijave</span>
                        <dropdownlist
                         name="vrsta"
                        :data-items="vrstaprijaveip"
                        :text-field="'naziv'"
                        v-model="ip.prijava.vrstaprijave"
                        />
            </label>

			<div class="display-flex" style="align-items:end;">  
			<label for="datumpregleda" class="k-form-field">
            <span>Datum pregleda</span>
             <kendo-datepicker id="datumpregleda"
                       v-model="ip.prijava.datumpregleda"
                       :format="'dd.MM.yyyy'">
            </kendo-datepicker>
            </label>

			<label for="pregledal" class="k-form-field">
            <span>Pregledal</span>
            <input type="text" v-model="ip.prijava.pregledal" placeholder="" name="pregledal" id="pregledal" class="k-textbox" />
            </label>
			</div>

			<div class="display-flex" style="align-items:center;gap:1rem;">  
			<span class="k-form-field">Prijava popolna</span>
			<input type="checkbox" v-model="ip.prijava.popolna"  name="popolnaprijava" id="popolnaprijava" class="k-checkbox k-form-field" />
			<label v-if="ip.prijava.popolna" for="datumpopolnosti" class="k-form-field">
            <kendo-datepicker id="datumpopolnosti"
                       v-model="ip.prijava.datumpopolnosti"
                       :format="'dd.MM.yyyy'">
            </kendo-datepicker>
            </label>

			</div>

			<!-- manjkajoči elementi   -->
			<div style="margin-top:2rem">
            <div class="form-fieldset-header display-flex" style="align-items:center;gap:1rem;">
               <h2 >Manjkajoči elementi</h2>
            </div>
 			<Grid  
                :data-items="ip.prijava.manjkajocielementi"
                :columns='[
                    { field: "datumprejema", title:"Datum prejema",editable:true, type:"date",editor:"date",format:"{0:d}",width: "150px"},
					{ field: "vsebina", title:"Vsebina",editable:true,width: "150px"},
					{ field: "pregledal", title:"Pregledal",editable:true,width: "150px"},
					{ cell: "brisi", filterable: false, width: "220px" }
                        ]'
                        :filterable="false"
                        :sortable="false"
                        @itemchange="manjkajocielementichange"
                        :edit-field="'edit'"
>
<template v-slot:brisi="{props}">
            <button class="k-button k-error " 
                    @click="removemanjkajocielementi(props.dataItem)"
                    >
                    Briši
            </button>
        </template>
    <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                        <button title="Dodaj"
                                class="k-button k-primary"
                                @click="dodajmanjkajocielementi"
                               >
                                Dodaj vrstico
                        </button>
                        </div>
                            
                        </toolbar>
                         <GridNoRecords >
                                        Ni podatkov!
                         </GridNoRecords>
</Grid>
</div>


<!-- obseg certificiranja   -->
<div style="margin-top:2rem">
            <div class="form-fieldset-header display-flex" style="align-items:center;gap:1rem;">
                <h2 >Obseg certificiranja</h2>
            </div>

			<template v-for="(podshema,i) in podrocjacertificiranja">
			<div class="display-flex" style="align-items:center;gap:1rem;">  
				<span>{{ podshema.naziv }}</span>
				<div class="k-form-field" style="flex: 1;">
            	<kendo-multiselect :value="ip.prijava.obseg[podshema.naziv]"
                        :data-items="ipobsegcertificiranjafilter[podshema.naziv]"
                        :text-field="'naziv'"
                        :data-item-key="'šifra'"
                        :placeholder="'Izberi'"
                        id="obseg"
                        @change="spremeniobseg($event,podshema.naziv)"
                        :messages="multiselectmessages"
                        :filterable="true"
						@filterchange="onFilterChange($event,podshema.naziv)"
                        :style="{ width: '400px'}"
                        >
            	</kendo-multiselect>
				</div>
                <span>{{ oblikujpovrsinova(ip.povrsine[podshema.naziv]) }} a</span>
			</div>
		</template>
 
</div>

<!-- obseg certificiranja 

					@add="onAdd"
					@remove="onRemove"
					@progress="onProgress"
					@statuschange="onStatusChange"
-->
<div style="margin-top:2rem;margin-bottom: 20rem;">
	<div class="display-flex" style="align-items:center;gap:1rem;">  
			
			
			<label for="datumseznama" class="k-form-field">
			<span class="k-form-field">Po seznamu z dne:</span>
            <kendo-datepicker id="datumseznama"
                       v-model="ip.prijava.datumseznama"
                       :format="'dd.MM.yyyy'">
            </kendo-datepicker>
            </label>

			<label for="priponkaseznam" class="k-form-field">
				<upload
					:files="files"
					:batch="false"
					:multiple="false"
					:with-credentials="false"
					@add="onAdd"
					@remove="onRemove"
					@progress="onProgress"
					@statuschange="onStatusChange"
					@beforeupload="authorize"
					@beforeremove="authorize"
					:save-url="saveurl"
					:remove-url="removeurl"
                    />
			</label>
			<label v-if="ip.prijava.seznam" for="prenesiseznam" class="k-form-field"></label>
			</div>
 
</div>

            </fieldset>
             </div>
             
               
          


           
                
             </div>
        </form>
    </div>
    </div>
    </div>
    </div>

</template>

<script>
import Vue from 'vue';
import { mapState, mapActions,mapMutations } from 'vuex';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { DatePicker } from '@progress/kendo-vue-dateinputs';
import { MultiSelect, DropDownList } from '@progress/kendo-vue-dropdowns';
import { filterBy } from '@progress/kendo-data-query';
import { provideIntlService } from '@progress/kendo-vue-intl';
import { Checkbox } from "@progress/kendo-vue-inputs";

import PridelovalecKratko from './support/PridelovalecKratko';
import { pridelavaService } from '../services/pridelava.service';
import { authHeader } from '../helpers';
import { Upload } from '@progress/kendo-vue-upload';

export default {
     components: {
    'kendo-datepicker': DatePicker,
    'kendo-multiselect': MultiSelect,
    'dropdownlist': DropDownList,
    'pridelovalec':PridelovalecKratko,
    'kendo-checkbox': Checkbox,
    'Grid': Grid,
     'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
	  upload: Upload,
  },
    props:['sezona','pridelovalecid','shema'],
    data () {
        return {
			      dataSezona:this.sezona,
                   sezone:[],
            ip:{
                individualno:true,
                skupnsko:false,
                status:{naziv:"aktiven",id:1},
                izbrandatumdolocitvestatusa:null,
                izbranosteviloclanov:0,
                izbrandatumdolocitvestevilaclanov:null,
                podrocjacertificiranja:[{naziv:"IPS",id:1},{naziv:"IPG",id:2}],
                osebe:[{}],
                podizvajalci:[{}],
				prijava:{datumpopolnosti:null,datumpregleda:null,datumprijave:null}

            },
            nacinprijaveip:[{naziv:"Pošta",id:0},{naziv:"E-pošta",id:1},{naziv:"Osebno",id:2},{naziv:"E-prijava",id:3}],
			vrstaprijaveip:[{naziv:"Prva prijava",id:0},{naziv:"Obnova prijave",id:1},{naziv:"Obnova prijave zaradi sprememb",id:2}],
			podrocjacertificiranja:[{naziv:"IPS",id:1},{naziv:"IPG",id:2},{naziv:"IPP",id:3},{naziv:"IPZ",id:4},{naziv:"IPH",id:5}],
            ipobsegcertificiranja:[],
			ipobsegcertificiranjafilter:{},
            kmgmid:"",posta:"",postnastevilka:"",naslov:"",ime:"",priimek:"",telefon:"",email:"",opomba:"",postnastevilkakontakt:"",postakontakt:"",postnastevilkanosilec:"",postnanosilec:"",naslovkontakt:"",priimekkontakt:"",postanosilca:"",postnastevilkanosilca:"",emso:"",imekontakt:"",kntst:"",
            emailnosilca:"",telefonnosilca:"",
           files:[],
            iscipodizvajalca:'',
            iscipodizvajalcaerror:'',
            password: '',
            submitted: false,
            multiselectmessages: 
            {
            "singleTag": "izbrani elementi",
            "clear": "Počisti",
            "deleteTag": "Izbriši",
            "noData": "Ni podatkov"
            },
            vrstapridelave:["EK+K","EK-P","P"],
            
            vrsta:[],
            status:[],
            statuskategorije:[],
            kategorije:[],
            eprijava:{}
        }
    },
    computed: {
		
		saveurl:{
            get(){
				return `${Vue.prototype.$config.apiUrl}/datoteke/dodaj`
			}
		},
		removeurl:{
            get(){
				return `${Vue.prototype.$config.apiUrl}/datoteke/brisi`
			}
		},
        kontakt:{
            get(){
                var kontakt=this.pridelovalec?.kontakt?.find(k=>k.glavni);
                if(!kontakt)
                kontakt=this.pridelovalec?.kontakt?.find(k=>k.vloga=='nosilec kmg');
                if(!kontakt)
                kontakt=this.pridelovalec?.kontakt[0];

                return kontakt;
            }
        },
		obsegcertificiranja:
        {
           get() {

            let pridelava=this.pridelovalec?.sheme?.find(s=>s.sezona==this.sezona&&s.shema==this.shema);

            if (pridelava)
                return pridelava.ip.obseg;
            else
                return [];

          }
        },
        
        ...mapState('users', ['sezonePisanje','sheme']),
        ...mapState('pridelava', ['pridelovalec']),
        ...mapState('sifrant', ['sifrant','dataSezone'])
        
    },
    created () {
      if(!this.sezona)
        this.dataSezona={sezona:2022};
      else
      this.dataSezona={sezona:this.sezona};
    
      if(!this.shema)
        this.shema="IP";
	    this.naloziPodatke(this.shema,this.sezona,this.pridelovalecid);
      // this.naloziPodatke();
     
    },
	beforeRouteUpdate (to, from,next) {
    	this.naloziPodatke(to.params.shema,to.params.sezona,to.params.pridelovalecid,next);
	},
    methods: {
        
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapActions('pridelava',['loadOne','save','loadIdPoSezoni']),
         ...mapMutations('pridelava',['updateprop','updateshemaprop']),

		authorize(event) {
			event.headers=authHeader();
		},
        oblikujpovrsinova(povrsina) {
            if(!povrsina)
                povrsina=0;

                return povrsina.toFixed(2);

        },
		onAdd(event) {
		
        this.files=event.newState;
      },
      onRemove(event) {
        this.files=event.newState;
      },
      onProgress(event) {
		console.log("progres");
		console.log(event);
		this.files=event.newState;
      },
      onStatusChange(event) {
		
		console.log("done");
		console.log(event)
		this.files=event.newState;
		Vue.set(this.ip.prijava,'seznam',{datotekaid:event.response?.response?._id,files:this.files});
      },
		spremeniobseg (event,podshema)  {
			console.log(event.target.value);
			//let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.sezona&&s.shema==this.shema);
            Vue.set(this.ip.prijava.obseg,podshema,[...event.target.value])
			console.log(this.ip.prijava.obseg);
        },
        dodajmanjkajocielementi(){
			console.log("PUSHAM")
            if(!this?.ip?.prijava?.manjkajocielementi)
                this.ip.prijava.manjkajocielementi=[];

            const newRecord = { id: this.ip.prijava.manjkajocielementi.length + 1,datumprejema:new Date(),vsebina:'',pregledal:'',edit:true };
            this.ip.prijava.manjkajocielementi.push(newRecord);
        }   ,
        removemanjkajocielementi(e){
        
                var index=this.ip.prijava.manjkajocielementi.indexOf(e);
                if(index>=0)
                        this.ip.prijava.manjkajocielementi.splice(index,1)

        },
        manjkajocielementichange: function (e) {
            e.dataItem[e.field]=e.value;

     
  
},

        saveData(e){
          this.save( this.dataSezona);
        },
          handleSubmit(e){

          e.preventDefault();
        },
        cancel(e){
			this.$router.push({ name: 'sheme', params: { sezona:sezona.sezona,shema:this.shema},query:{shema:this.shema,sezona:this.sezona} })
        },
       
		naloziPodatke (shema,sezona,pridelovalecid,next){
            // this.dataSezona={sezona:this.sezona};
       // this.dataSezone
//         this.sifrant["statuspridelovalca"]
  //       this.sifrant["vrstapridelovalca"]
         var thisComp=this;
        this.naloziSifrant({sezona:sezona,sifrant:"ipobsegcertificiranja"}).then(()=>{
            thisComp.ipobsegcertificiranja=thisComp.sifrant["ipobsegcertificiranja"];
			for (let podshema of thisComp.podrocjacertificiranja)
				Vue.set(thisComp.ipobsegcertificiranjafilter,podshema.naziv,thisComp.ipobsegcertificiranja.filter(i=>i.področje==podshema.naziv).slice())
				
        });
       
        this.loadOne({sezona:sezona,pridelovalecid:pridelovalecid}).then(p=>{


            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==sezona&&s.shema==shema);
            if(!pridelava){
				//javi napako, ne dodaj podatkov
				console.log("resne težave, če ni sheme")
				return;
			}
			let novaprijava={
					nacinprijave:null,
					vrstaprijave:null,
					pregledal:'',popolna:false,manjkajocielementi:[],
                    //obseg:{},
					datumpopolnosti:(new Date()).toISOString(),
					datumpregleda:(new Date()).toISOString(),
					//datumprijave:(new Date()).toISOString(),
					seznam:{datotekaid:null,files:[]},
					datumseznama:(new Date()).toISOString()};

			if(!pridelava.ip)
			{

				//javi napako, ne dodaj podatkov
			
				Vue.set(pridelava.ip,'prijava',novaprijava)
			}
                
            //provideIntlService(this).parseDate(pridelava.datumDolocitve);
			if(!pridelava.ip.prijava){
				Vue.set(pridelava.ip,'prijava',novaprijava)
				
			}
            let eprijava=p.prijave.filter(i=>i.shema=='IP'&&i.sezona==sezona-1).sort((a,b)=>(new Date(b.updatedAt)-new Date(a.updatedAt)))[0]
            if(eprijava){
                console.log("IMAM PRIJAVo!!!")
                console.log(pridelava.ip.prijava);
                //način e-prijava
                //Vrsta obnova prijave
                if(!pridelava.ip.prijava.datumprijave)
                    pridelava.ip.prijava.datumprijave=eprijava.prijava.datumoddaje;
                if(!pridelava.ip.prijava.vrstaprijave)
                    pridelava.ip.prijava.vrstaprijave={naziv:"Obnova prijave",id:1};
                if(!pridelava.ip.prijava.nacinprijave)
                    pridelava.ip.prijava.nacinprijave={naziv:"E-prijava",id:3};
                if(!pridelava.ip.prijava.obseg)
                    pridelava.ip.prijava.obseg=eprijava.prijava.obseg;
                if(!pridelava.ip.obsegcertificiranja)
                    pridelava.ip.podrocjacertificiranja=this.podrocjacertificiranja.map(i=>{
                    let pc={naziv:i.naziv,id:i.id};
                    if(eprijava.prijava.podrocja[i.naziv])
                        pc.status={naziv: "aktiven", id: 1};
                    else
                        pc.status={naziv: "neaktiven", id: 0};
                        pc.izbrandatumdolocitvestatusa=eprijava.updatedAt;
                    return pc;
                })
                if(!pridelava.ip.osebe[0])
                    pridelava.ip.osebe.push({email:eprijava.prijava.emailoo,naziv:eprijava.prijava.odgovornaoseba,telefon:eprijava.prijava.telefonoo});
                
                //prenesi davčni zavezanec??
                //default individualno certificiranje, cena po ceniku, prejemnik e-računa, ....
                //kako popraviti kontakte...
                //prenesi gerke
                //naredi povezavo do prijave

               


            }
            this.eprijava=eprijava;
            if(!pridelava.ip.prijava.obseg)
                 pridelava.ip.prijava.obseg={};
            if(!pridelava.ip.prijava.datumprijave)
                pridelava.ip.prijava.datumprijave=(new Date()).toISOString();
                  
            //če so gerki oz. če je prijava...
            let povrsine={};
            for(let pc of pridelava.ip.podrocjacertificiranja.filter(p=>p.status.id==1)){
                let gerkipc=p.gerki.filter(g=>g.sezona==sezona&&g?.kontrolaIP&&g.kontrolaIP[pc.naziv]);
                if((!gerkipc||gerkipc.length==0)&&eprijava){
                    gerkipc=eprijava.prijava.gerki.filter(g=>g?.kontrolaIP&&g.kontrolaIP[pc.naziv]);
                }
                let vsota=gerkipc.reduce((a,c)=>{return a+=c.povrsina; },0)
                povrsine[pc.naziv]=vsota;

            }
            pridelava.ip.povrsine=povrsine;

			pridelava.ip.prijava.datumpregleda=provideIntlService(thisComp).parseDate( pridelava.ip.prijava.datumpregleda);
            pridelava.ip.prijava.datumpopolnosti=provideIntlService(thisComp).parseDate(pridelava.ip.prijava.datumpopolnosti)
			pridelava.ip.prijava.datumprijave=provideIntlService(thisComp).parseDate(pridelava.ip.prijava.datumprijave)
			pridelava.ip.prijava.datumseznama=provideIntlService(thisComp).parseDate(pridelava.ip.prijava.datumseznama)
      
			
            Vue.set(thisComp,"ip",pridelava.ip)
			thisComp.files=thisComp.ip.prijava?.seznam?.files;
			if(!thisComp.ip.prijava.obseg||Array.isArray(thisComp.ip.prijava.obseg))
				Vue.set(thisComp.ip.prijava,'obseg',{});

			console.log(thisComp.ip);
			thisComp.ip.prijava.manjkajocielementi=thisComp.ip.prijava.manjkajocielementi.map(k=>{
            k["datumprejema"]=kendo.parseDate(k["datumprejema"]) 
            return k;
        } );   

            
            
            if(next)
                next();
            
        });
      
        },
		onFilterChange(event,podshema) {
			console.log(podshema)
            
			Vue.set(this.ipobsegcertificiranjafilter,podshema,filterBy(this.ipobsegcertificiranja.filter(i=>i.področje==podshema).slice(), event.filter))
			console.log(this.ipobsegcertificiranjafilter[podshema])
        },
         sezonaChange(event) {
         
            const sezona = event.value;
            this.dataSezona=sezona;
            this.$router.push({ name: 'ipprijava', params: { sezona:sezona.sezona,shema:this.shema,pridelovalecid:this.pridelovalecid} })
            /*
            this.loadIdPoSezoni({sezona:sezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
              this.pridelovalecid=pridelovalec.id;
             this.$router.push({ name: 'pridelovalec', params: {sezona:sezona.sezona,pridelovalecid:pridelovalec.id} });
             this.naloziPodatke();
              });

*/
          //  this.naloziPodatke();



        },
    }
};
</script>

<style scoped>

.izbranakategorija{
   background-color: var(--accent);
   
}
.k-checkbox-field {
    display: flex !important;
    align-items: center;
}
.kat_chk_list{
display:flex;
flex-direction:column;

}

form {
display:flex;
flex-direction:column;
}

.k-checkbox-field input[type="checkbox"]{
    margin-left: 0.5rem;

}
</style>